// --- 定数定義 ---
export const GAME_DURATION = 30;
export const HIRAGANA_SOURCE = "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわ";

// バックエンドのURL
// バックエンドのURL (Docker環境での安定動作のため直接指定)
export const API_URL = process.env.REACT_APP_API_URL || "";

// --- ユーティリティ関数 ---

// カタカナ -> ひらがな変換
export const toHiragana = (str) => {
  return str.replace(/[\u30a1-\u30f6]/g, function(match) {
    const chr = match.charCodeAt(0) - 0x60;
    return String.fromCharCode(chr);
  });
};

// 漢字が含まれているか判定
export const hasKanji = (str) => {
  return /[一-龠]/.test(str);
};
